import { CHANNEL, alignChannelFromBackend } from 'src/data/channel';
import { INTEGRATION_CHANNELS, PERFORMANCE_CHANNELS, PLATFORM_CHANNELS } from './const';
import { SUGGESTED_ANNOTATIONS_ORIGIN } from './annotationsOrigin';
import { isDisconnectedStatus } from 'src/store';
import { isEmailCsvResourceDocument } from './resources';

const DELIMITER = '__';

export const hashResource = ({ channel, accountId, name, id }) =>
  [channel, accountId, name, id].join(DELIMITER);

export const isHashedResource = (value) => value?.includes(DELIMITER);

export const getChannelFromHashedResource = (value) =>
  isHashedResource(value) ? value.split(DELIMITER)[0] : value;
export const getAccountIdFromHashedResource = (value) => value.split(DELIMITER)[1];
export const getNameFromHashedResource = (value) => value.split(DELIMITER)[2];
export const getIdFromHashedResource = (value) => value.split(DELIMITER)[3];

export const isChannelSuggestedAnnotationsOrigin = (suggestedAnnotationsOrigin) =>
  PERFORMANCE_CHANNELS.includes(getChannelFromHashedResource(suggestedAnnotationsOrigin));

export const isIntegrationChannel = (channel) => INTEGRATION_CHANNELS.includes(channel);

export const isPlatformChannel = (channel) => PLATFORM_CHANNELS.includes(channel);

export const isMetaChannel = (channel) =>
  [CHANNEL.facebook, CHANNEL.facebookPages, CHANNEL.instagram].includes(channel);

export const flatConnectedAccounts = (connectedAccounts, withResources) =>
  withResources
    ? Object.values(connectedAccounts || {}).reduce((acc, accounts) => {
        return acc.concat(accounts);
      }, [])
    : Object.keys(connectedAccounts || {}).reduce((acc, channel) => {
        if (isIntegrationChannel(channel)) {
          return acc.concat(connectedAccounts[channel]);
        }
        return acc;
      }, []);

export const shouldShowLoaderForSuggestedTalkingPoints = ({
  loadingStatus,
  channel,
  isResource,
  isExtractingTalkingPointsView,
}) => {
  if (!channel || channel === SUGGESTED_ANNOTATIONS_ORIGIN.anyword) {
    return false;
  }
  if (isResource) {
    return isExtractingTalkingPointsView;
  } else {
    const channelLoadingAccountsStatus = Object.values(loadingStatus[channel] || {});
    return channelLoadingAccountsStatus.some((value) => value);
  }
};

export const getAssociatedAccountIds = (workspace) => {
  const { associatedIntegrationIds } = workspace.associatedAccounts.reduce(
    (acc, account) => {
      if (
        (isIntegrationChannel(alignChannelFromBackend(account.accountType)) ||
          isEmailCsvResourceDocument(account.accountType)) &&
        !isDisconnectedStatus(account.status)
      ) {
        acc.associatedIntegrationIds.push(account.accountId);
      }
      return acc;
    },
    { associatedIntegrationIds: [] }
  );

  return { associatedIntegrationIds };
};

export const isBlogUrlsChannel = (channel) => channel === CHANNEL.blogUrls;
